import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationUpdateProjectArgs, BackendProject } from 'src/types/backend';

const MUTATION = gql`
  mutation UpdateProjectBrandVoicesForBrandTerms($id: Int!, $brandVoiceIdsForBrandTerms: [ID!]) {
    updateProject(id: $id, brandVoiceIdsForBrandTerms: $brandVoiceIdsForBrandTerms) {
      id
    }
  }
`;

type Variables = Pick<BackendMutationUpdateProjectArgs, 'id' | 'brandVoiceIdsForBrandTerms'>;
type Result = Pick<BackendProject, 'id'>;

export const updateProjectBrandVoicesForBrandTerms = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
